module.exports = {"330803001":"樟潭街道","330803002":"浮石街道","330803100":"上方镇","330803101":"峡川镇","330803103":"莲花镇","330803109":"全旺镇","330803110":"大洲镇","330803111":"后溪镇","330803112":"廿里镇","330803113":"湖南镇","330803114":"高家镇","330803115":"杜泽镇","330803200":"灰坪乡","330803202":"太真乡","330803203":"双桥乡","330803206":"周家乡","330803207":"云溪乡","330803213":"举村乡","330803218":"岭洋乡","330803219":"黄坛口乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330803.json
// module id = 1110
// module chunks = 0